// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { LinkFragmentDoc } from '../../../graphql/api/cms/link.fragment.generated';
export const ComponentIconCarouselFragmentDoc = gql`
    fragment componentIconCarousel on ComponentIconCarousel {
  items {
    icon
    text
    itemLink: link {
      ...link
    }
  }
}
    ${LinkFragmentDoc}`;